// Field + preset config for the Virtual Accounts FilterBuilder.
//
// Only these columns are exposed. `id` is deliberately excluded: the server
// reserves it for the keyset cursor, so a client `id` condition would be
// silently overwritten. The serializer (serializeWhere.js) enforces the same
// allow-list defensively.
//
// The old `?q=` free-text search matched acc_num (exact), acc_name (partial),
// and meter (exact). Those remain reachable here: acc_num via $eq/$substring,
// acc_name via $like/$substring, meter via $eq.

export const PROVIDERS = [
  'PAYANT',
  'MONNIFY',
  'PAYSTACK',
  'BUYPOWER',
  'BUYPOWER_MFB',
];

export const ACCOUNT_TYPES = ['USER', 'MERCHANT', 'API_USER'];

// Relative-date literals the API substitutes server-side (sqlize-query). Offered
// as presets on datetime fields so users can filter e.g. "last 24 hours" without
// picking an absolute timestamp. Sent verbatim as the condition value.
export const DATE_PRESETS = [
  { value: '@NOW', label: 'Now' },
  { value: '@LAST_10_MINUTES', label: 'Last 10 minutes' },
  { value: '@LAST_24_HOURS', label: 'Last 24 hours' },
  { value: '@TODAY', label: 'Today' },
  { value: '@YESTERDAY', label: 'Yesterday' },
  { value: '@THIS_WEEK', label: 'This week' },
  { value: '@LAST_WEEK', label: 'Last week' },
  { value: '@THIS_MONTH', label: 'This month' },
  { value: '@LAST_MONTH', label: 'Last month' },
];

// Reuses the shared FilterBuilder component. `presets` on the date field is an
// optional, backward-compatible extension read only by FilterBuilder's value
// input (see FilterBuilder.js).
export const VIRTUAL_ACCOUNT_FIELDS = [
  { key: 'acc_num', label: 'Account Number', type: 'string' },
  { key: 'acc_name', label: 'Account Name', type: 'string' },
  { key: 'meter', label: 'Meter', type: 'string' },
  { key: 'phone', label: 'Phone', type: 'string' },
  { key: 'provider', label: 'Provider', type: 'enum', options: PROVIDERS },
  {
    key: 'account_type',
    label: 'Account Type',
    type: 'enum',
    options: ACCOUNT_TYPES,
  },
  { key: 'disco', label: 'Disco', type: 'string' },
  { key: 'bank', label: 'Bank', type: 'string' },
  { key: 'active', label: 'Active', type: 'boolean' },
  { key: 'reserved', label: 'Reserved', type: 'boolean' },
  { key: 'created_at', label: 'Created', type: 'date', presets: DATE_PRESETS },
];

// Column allow-list for the serializer — never contains `id`.
export const ALLOWED_FIELDS = VIRTUAL_ACCOUNT_FIELDS.map((f) => f.key);
